import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { User } from '@/interfaces/vuex/user';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSendActivationDialog',
  props: {
    value: { type: Boolean },
    user: null
  },
  emits: ["input", "send"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'send', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  user?: User;
};

const m = defineMessages({
  resendConfirmationEmail: 'アカウント有効化メールを送信しますか？',
  sendEmailPrompt:
    '「送信する」をクリックすると、以下のメールアドレスにアカウント有効化用のメールが送信されます。',
  completeRegistrationNote:
    '※ 送信後は24時間以内にアカウントの有効化を完了してください。',
});




const localValue = ref(props.value);

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

const closeDialog = () => {
  emits('input', false);
};

const handleSendActivationClick = async () => {
  if (!props.user) {
    throw new Error('User is required');
  }
  emits('send', props.user.email);
  closeDialog();
};

return { __sfc: true,m, props, emits, localValue, closeDialog, handleSendActivationClick, BaseFormCard, sharedMessages }
}

})